export enum ConfirmDialogAnswers {
  YES,
  NO,
  SAVE_AND_EXIT
}
